/**
 * Reducer for any errors that might need to appear
 */

import { ActionTypes as types, SEND_MONEY_ERRORS } from '../constants'

function getInitialState() {
  return {
    overpanel: undefined,
    page: undefined,
    error: undefined,
  }
}

export default function errors(state = getInitialState(), action) {
  switch (action.type) {
    case types.ERROR.SHOW_ERROR_OVERPANEL:
      const error = action.data.error

      return {
        ...state,
        overpanel: {
          ...error,
          hideServiceMessage:
            error &&
            (error.code === SEND_MONEY_ERRORS.INSTRUMENT_DEBIT_FAILED ||
              error.code === 'requesterAccountRestricted' ||
              error.code === 'blockedSend' ||
              error.code === 'blockedRequest' ||
              error.code === 'errorTransactionDeclinedNegativeBalance' ||
              error.code === SEND_MONEY_ERRORS.COUNTRY_DISALLOWED ||
              error.code === SEND_MONEY_ERRORS.SHOP_ITEM_UNAVAILABLE),
        },
        error,
      }
    // closing the error overpanel should clear out the error
    case types.OVERPANELS.TOGGLE_ERROR_OVERPANEL:
      return {
        ...state,
        overpanel: !action.data.show ? undefined : state.overpanel,
      }
    // any route change should clear out the error
    case types.ROUTER.LOCATION_CHANGE:
      return {
        ...state,
        overpanel: undefined,
        page: undefined,
      }
    case types.ERROR.SHOW_ERROR_PAGE:
      return {
        ...state,
        page: action.data.error,
      }

    default:
      return state
  }
}
